
import { ModelBase } from 'store/model-base';

export class SendPortOutPin extends ModelBase {
    public static storeName: string = 'sendPortOutPin';

    public notificationStatus: string;
    public isSuccess: boolean;


    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: SendPortOutPin = super.create<SendPortOutPin>(initData);
        toReturn.isSuccess = toReturn.notificationStatus === 'SUCCESS';

        return super.create<T>(toReturn);
    }
}
